// extracted by mini-css-extract-plugin
export default {"InfoModal":"InfoModal_InfoModal__WSRxT"};